'use client';

import { AccountMenu } from '@/app_components/header/AccountMenu';
import { SignInButton } from '@/app_components/header/SignInButton';
import { SubscribeButton } from '@/app_components/header/SubscribeButton';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { useUser } from '@/app_lib/providers/UserProvider';
import { isUserSubscribed } from '@/app_lib/utils/clientUtils';

export const AuthMenu = () => {
  const { pianoLoadingState, userAccess } = useUser();
  const { loggedIn, hasAccess, isPaused } = userAccess;
  const loading = pianoLoadingState !== 'loaded' || loggedIn === undefined;

  const content = (
    <div className='flex gap-4 lg:gap-6 justify-end'>
      {/* Show the subscribe button only for users who are not logged in, or are logged in but neither subscribed nor paused */}
      {!isUserSubscribed(loggedIn, hasAccess, isPaused) && (
        <div className='inline-block'>
          <SubscribeButton noCapitalize>
            <span className='md:hidden'>Subscribe for $1</span>
            <span className='hidden md:inline'>Subscribe for $1</span>
          </SubscribeButton>
        </div>
      )}
      {loggedIn ? <AccountMenu /> : <SignInButton className='hidden md:inline-block' />}
    </div>
  );

  return loading ? (
    <ButtonV2
      as='button'
      className='w-full bg-helper! animate-pulse rounded-full'
    >
      <span className='invisible'>Subscribe</span>
    </ButtonV2>
  ) : (
    content
  );
};
